
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import Heading from "@/components/base/Heading.vue";
import SupportDialogBtn from "@/components/support-dialog/SupportDialogBtn.vue";
import TopAppBar from "@/components/base/TopAppBar.vue";
import { IS_MOBILE_SYMBOL } from "@/constants";

class Question {
  public index = -1;

  constructor(
    public question: string,
    public answer: string,
    public id?: string,
    public expanded: boolean = true
  ) {}
}

@Component({
  components: {
    Heading,
    SupportDialogBtn,
    TopAppBar,
  },
  metaInfo: {
    title: "Поддержка",
  },
})
export default class FAQ extends Vue {
  @Inject(IS_MOBILE_SYMBOL) isMobile!: boolean;
  private search: string | null = null;
  private isMounted = false;
  private panel: number[] = [];
  private showSearch = false;
  private questions = Object.freeze([
    new Question(
      "Что такое бонусный баланс?",
      "Бонусный баланс - это дополнительная валюта, которую можно потратить на открытие бонусных кейсов. Данную валюту можно получить с помощью специальных промокодов. Бонусный баланс можно потратить открывая Оружейные кейсы без 100% окупаемости, оплатив 20% стоимости кейса своим бонусным балансом.",
      "bonusBalance"
    ),
    new Question(
      "Как получить осколки?",
      "Осколки - это новая валюта сайта на время весеннего ивента. Осколки можно получить открывая обычные кейсы. Чтобы открыть весенний кейс необходимо собрать 4 осколка одного типа.",
      "getFragments"
    ),
    new Question(
      "Кому писать, если что-то пошло не так?",
      "Если у вас возникли те или иные трудности связанные с сайтом, Вы можете обратится в <a href='#open-support-dialog'>тех-поддержку</a> сайта.",
      "how"
    ),
    new Question(
      "Что делать, если мне выпал скин который дешевле стоимости кейса в режиме со 100% окупаемостью?",
      "В случае, если вы получили скин дешевле стоимости  кейса в режиме 100% окупаемости, рекомендуем вам обратиться в службу поддержки до вывода или продажи скина сайту.<br> Мы вернем вам деньги за кейс либо компенсируем балансом.",
      "how"
    ),
    new Question(
      "Как работает опен-кейс со 100% окупаемостью?",
      "Покупая у нас товар, например, на 100 рублей, вы гарантированно получаете вещь стоимостью дороже 100 рублей (по ценам steam analyst).<br >  Цены обновляются 2 раза в день; следовательно, цена в момент вашей покупки только в очень редких случаях может отличаться от цены analyst’а в момент загрузки поставок. Случаев, когда клиент получает вещь дешевле затраченной суммы, почти не существует!",
      "how1"
    ),
    new Question(
      "Что такое снежинки?",
      "Снежинки - это новогодняя валюта, которую можно потратить на открытие новогодних кейсов. Данная валюта будет существовать до конца новогоднего события.<br> <br>Вы можете получить снежинки, открывая любые кейсы или играя в апгрейд. <br> Количество снежинок за одно открытие / игру варируется случайным образом от 2 до 3 процентов от потраченной вами суммы.",
      "getSnowBalance"
    ),
    new Question("Как играть в режим сражения?", "Сражение - ", "battle"),
    new Question(
      "Почему нам можно доверять?",
      "<ul><li>Наш сайт существует более 5 лет.</li><br><li>Вы легко можете найти обзоры нашего сайта на просторах видеохостинга YouTube.</li></ul>",
      "how2"
    ),
    new Question(
      "В каких случаях производится возврат денежных средств?",
      "<ul><li>Пользователь купил оружие одновременно с другим покупателем</li><br><li>Лаги стима (из-за лага могут не дойти единичные трейды, а иногда сервера полностью лежат по несколько часов)</li><br><li>Другие проблемы, связанные с нашим оборудованием (ботом, кошельком и т. д.)</li></ul>",
      "how3"
    ),
    new Question(
      "Как оплатить и получить вещь?",
      'Вещи после оплаты можно забрать в Личном кабинете, вещи придут в течении 2-х минут.<br><br><ul><li>Найти свою трейд ссылку и проверить ее работоспособность.(Иначе бот не сможет отправить Вам вещи - это не является проблемой магазина.)<br>Свою трейд ссылку можно найти следующим образом:<br> Инвентарь -&gt; Предложения обмена -&gt; Кто может отправлять обмен? -&gt; Копируете выданную вам трейд ссылку. </li><br><li>Вставить свою трейд ссылку в специальное поле в профиле на сайте</li><br><li>Открыть понравившийся кейс</li><br><li>После открытия всех кейсов зайти в профиль на сайте и нажать кнопку "отправить вещи"</li><br><li>Принять оффер и оставить отзыв (по желанию)<br>!!! Если вы не примите вещь в течение 2-ух дней с момента покупки, то она может быть продана другому пользователю. В данном случае Администрация не обязана возвращать средства или вещи. </li></ul>',
      "how4"
    ),
    new Question(
      "В каких случаях НЕ производится возврат денежных средств?",
      "<ul><li>Покупатель поставил приватный профиль</li><br><li>Покупатель поставил скрытый инвентарь</li><br><li>Покупатель недавно сменил пароль / e-mail, из-за чего был заблокирован в системе обмена</li><br><li>Трейд ссылка покупателя недоступна по каким-либо другим причинам(новорег).</li><br><li>Покупатель не указал обязательный комментарий при покупке через QIWI напрямую</li></ul>",
      "how5"
    ),
    new Question(
      "Как пополнять скинами?",
      "При пополнении баланса скинами у вас несколько вариантов:<br><br><ul><li>Пополнить баланс скинами</li><br><li>Пополнить баланс деньгами</li></ul><br> Все доступные методы оплаты представлены в <a href='profile#deposit' >профиле</a>.",
      "how6"
    ),
    new Question(
      "Расписание поставок скинов",
      "<ul><li>Поставки скинов производятся ежедневно с 11 часов утра по Мск и до 14:00, возможны также дополнительные пополнения в течение дня.</li><br><li> Поставки аккаунтов не имеют расписания, поэтому могут появится в любой момент.<ul></li>",
      "how7"
    ),
    new Question(
      "Почему не приходят скины?",
      "<ul><li>Ошибка 15 - Вам нужно обновить трейд ссылку в профиле(сгенерировать новую)</li><br><li>Ошибка 26 - Вещь уже продана другому человеку</li><br><li>Ошибка 25 - Лаги стима</li></ul>",
      "how8"
    ),
    new Question(
      "Можно ли продать скин за киви или баланс сайту?",
      "Да, можно, но берется комиссия, так например при продаже скина сстоимостью в 100р, вы получите на киви или баланс сайта 72 рубля(комиссия 28%).<br><br>\n" +
        "Мы не можем покупать скины по цене 1к1 в стиме, так как сайт всегда выдает скины дороже чем стоимость кейса(но это относится только к основному режиму со 100% окупаемостью на главной странице), иначе мы уходили бы в минус при продаже 1к1)<br><br>\n" +
        "Мы гарантируем окупаемость скина по ценам стим, если такого не случилось - отпишите в поддержку для компенcации.",
      "how9"
    ),
    new Question(
      "Мне не пришли деньги, что делать?",
      "Возможно вы забыли указать код или ошиблись, а может быть проблема на стороне киви - для зачисления платежа достаточно обратиться в службу поддержки на нашем сайте. Все денежные средства зачисляются поддержкой даже если вы забыли ввести код.",
      "how10"
    ),
    new Question(
      "Мне дали неверные данные от аккаунта, что делать?",
      "Для разрешения данной проблемы обратитесь в службу поддержки на сайте. Все аккаунты проверяются перед продажей, попробуйте еще раз на всякий случай.",
      "how11"
    ),
    new Question(
      "Кто отвечает за хранение аккаунта?",
      "С момента покупки аккаунта, только Вы отвечаете за его хранение. Если аккаунт будет удален на сайте, скачать вы его уже не сможете",
      "how121"
    ),
    new Question(
      "Как происходит покупка аккаунта?",
      '<h3>ВАЖНО ПЕРЕД ПОКУПКОЙ!<br><br></h3>Оплачивая аккаунт вы получаете данные от аккаунта и гайд по установке аутентификатора.<br>Вы получаете аккаунт, стоимость вещей которых в 4 раза превышает ваши вложения, ОДНАКО,<br>на аккаунте заблокирована система трейда, заблокирована возможность пользования торговой площадкой и активации цифровых ключей.На аккаунте ЕСТЬ возможность(она бесплатная) играть в CS:GO.<br>На некоторых аккаунтах нет доступа к почте или вовсе отсутствуют данные. Это значит что почты удалены, либо не подлежат восстановлению. Вы можете перепривязать новую почту через steam в настройках.<h3>ПРИОБРЕТАЕМЫЕ ИНВЕНТАРИ НЕ КРАДЕННЫЕ, ОНИ НАШИ - НИКТО ВОССТАНАВЛИВАТЬ ИХ НЕ БУДЕТ, ОБ ЭТОМ МОЖЕТЕ НЕ ПЕРЕЖИВАТЬ!</h3>Для установки аккаунта и способа авторизации, а также подтверждения трейдов нам не нужен телефон, а нужна следующая программа. <br><a style="color:#fc972b;" href="https://github.com/Jessecar96/SteamDesktopAuthenticator/releases" target="_blank">https://github.com/Jessecar96/SteamDesktopAuthenticat..</a><br><br>Устанавливаем, выбираем следующее:<br>"I already setup an another computer" <br>Выбираем файл с форматом .mafile, который ушел в архиве. Вуаля - аккаунт ваш, что может быть проще? Подтверждение трейдов и получения кода в этой же программе! Можно ставить несколько аккаунтов. <br>В случае возникновения вопросов, обращайтесь в саппорт на нашем сайте, с радостью вам поможем:)',
      "howItWorks"
    ),
  ]);

  get sortedQuestions() {
    let questions = this.questions.slice();
    if (this.searchQuestion) {
      questions.splice(
        questions.findIndex((k) => k === this.searchQuestion),
        1
      );
      questions.unshift(this.searchQuestion);
    }
    return questions;
  }

  get searchQuestion() {
    return this.questions.find(({ id }) => id === this.search);
  }

  created() {
    this.panel = this.questions
      .map(({ expanded }, index) => (expanded ? index : null))
      .filter((n) => typeof n === "number") as number[];
    this.search = this.$route.hash?.replace("#", "") || null;
  }

  mounted() {
    this.isMounted = true;
  }

  @Watch(`$route.hash`, { immediate: true })
  watchRouteHash(value) {
    const watcher = () => {
      if (value === "#open-support-dialog") {
        this.$refs.supportDialogBtn!["click"]();
      }
    };

    if (this.isMounted) {
      watcher();
    } else {
      const unwatch = this.$watch("isMounted", () => {
        unwatch();
        watcher();
      });
    }
  }

  async toggleShowSearch() {
    this.showSearch = !this.showSearch;
    await this.$nextTick();

    if (!this.showSearch) {
      this.search = null;
    }
  }
}
